import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { CompanyService } from '../services/company.service';

/** Resolves once the company finished loading (null if that failed). */
function loadedCompany() {
  const companyService = inject(CompanyService);
  return toObservable(companyService.loaded).pipe(
    filter(Boolean),
    take(1),
    map(() => companyService.company()),
  );
}

/** Stripe pages: a network member has no Stripe account and gets its payouts view. */
export const notMemberGuard: CanActivateFn = () => {
  const router = inject(Router);
  return loadedCompany().pipe(
    map((company) => (company?.is_member ? router.createUrlTree(['/payouts']) : true)),
  );
};

/** The payouts view is for network members; everyone else has the Stripe dashboard. */
export const memberGuard: CanActivateFn = () => {
  const router = inject(Router);
  return loadedCompany().pipe(
    map((company) => (company?.is_member ? true : router.createUrlTree(['/financial-dashboard']))),
  );
};
